import { config } from "config";

const APP_URL = config.openWidgetUrl;

export const OpenWidget = {
  Configurator: `${APP_URL}/configurator/customize-look?utm_source=app.helpdesk.com&utm_medium=integration&utm_campaign=widget-settings`,
  Preview: `${APP_URL}/share/`,
};
